import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import EN from './en';
import FR from './fr';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: EN },
      fr: { translation: FR }
    },
    lng: localStorage.getItem('activeLanguage') ?? 'en', // default language
    fallbackLng: 'en', // fallback language
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    react: {
      useSuspense: false // set to false to avoid suspense fallback
    }
  });
export default i18n;
